import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  TrackingPageRootComponent,
  TrackingPageNumbersComponent,
  TrackingPageSearchPageComponent
} from './containers';
import { TrackingPageGuard } from './guards';

const routes: Routes = [
  {
    path: '',
    component: TrackingPageRootComponent,
    children: [
      {
        path: 'search',
        component: TrackingPageSearchPageComponent
      },
      {
        path: 'mock',
        loadChildren: () =>
          import('./mock-tracking-page/mock-tracking-page.module').then(
            m => m.MockTrackingPageModule
          )
      },
      {
        path: ':hash',
        component: TrackingPageNumbersComponent,
        canActivate: [TrackingPageGuard]
      },
      {
        path: '',
        component: TrackingPageNumbersComponent,
        canActivate: [TrackingPageGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrackingPageRoutingModule {}
